import Vue from 'vue'
import iview from 'iview'
if (window.location.href.indexOf("192.168") < 0 && window.location.href.indexOf("localhost") < 0) {
    console.log = function () { }
}
import VueBus from "vue-bus";
Vue.use(VueBus);
import App from "./App";
import router from "./router";
import store from "./store/";
import glb from './Global';
import "./assets/css/public.css";
import "./mythem/index.less";
import "beilie-ui-lib/dist/beilie-ui-lib.css"
import lib from "beilie-ui-lib"
import token from "./token"

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
// 国际化
const i18n = new VueI18n({
    locale: "zh", //当前语言环境
    messages: { //语言文件对应语言环境的map集合，value值代表着语言文件的相对地址
        zh: require('./assets/langs/zh.json'),
        en: require('./assets/langs/en.json')
    }
})
Vue.use(iview, {
    i18n: (key, value) => i18n.t(key, value)
})

Vue.use(lib)

//引入公共组件样式
import 'beilie-ui/dist/beilie-ui-min.css';
import 'beilie-ui/dist/beilie-theme-min.css';
import 'beilie-ui/dist/beilie-ui-min.js';
import 'beilie-ui/dist/beilie-api-min.js';
import 'beilie-ui/dist/beilie-theme-min.js';
import 'beilie-ui/dist/beilie-filter-min.js';


Vue.use(glb)
Vue.config.silent = false;
Vue.config.productionTip = false;
Vue.config.devtools = false;



// var aaa = false;
// Vue.prototype.$tquery.pushError((err) => {
//     if (aaa == true) {
//         return err;
//     }
//     if (err.response === undefined) {
//         // alert("后端返回的response为undefined")
//         aaa = true;
//         // window.location.reload();
//     } else {
//         return err;
//     }
//     // debugger
// })
// var axiosArr = ['es', 'em',  'op', 'plat', 'ea', 'oh',  'ohst', 'or'];
var axiosArr = ['es', 'em', 'oj', 'op', 'plat', 'oe', 'ea', 'oc', 'oh', 'ohst', 'or', 'osrd', 'esep', 'cb'];
axiosArr.forEach(item => {
    //七天令牌 **************开始*****************
    // 兼容
    Vue.prototype.$tquery.createApi(item, {
        prod: `/api/v1/${item}`,
        dev: `/api/v1/${item}`
    })
})

// *****************************API*********************
import ea from '@/plugins/EA_V1_api';
Vue.prototype.$api.ea = ea.createApi(Vue.prototype.$tquery.getApi("ea"));
import esep from '@/plugins/ESEP_v1_API';
Vue.prototype.$api.esep = esep.createApi(Vue.prototype.$tquery.getApi("esep"));
import oe from '@/plugins/OE_V1_API';
Vue.prototype.$api.oe = oe.createApi(Vue.prototype.$tquery.getApi("oe"));
import es from '@/plugins/ES_V1_API';
Vue.prototype.$api.es = es.createApi(Vue.prototype.$tquery.getApi("es"));
import em from '@/plugins/EM_V1_API';
Vue.prototype.$api.em = em.createApi(Vue.prototype.$tquery.getApi("em"));
import op from '@/plugins/OP_V1_API';
Vue.prototype.$api.op = op.createApi(Vue.prototype.$tquery.getApi("op"));
import plat from '@/plugins/PLAT_V1_API';
Vue.prototype.$api.plat = plat.createApi(Vue.prototype.$tquery.getApi("plat"));
import oc from '@/plugins/OC_V1_API';
Vue.prototype.$api.oc = oc.createApi(Vue.prototype.$tquery.getApi("oc"));
import oh from '@/plugins/OH_V1_API';
Vue.prototype.$api.oh = oh.createApi(Vue.prototype.$tquery.getApi("oh"));
import oj from '@/plugins/OJ_V1_API';
Vue.prototype.$api.oj = oj.createApi(Vue.prototype.$tquery.getApi("oj"));
import ohst from '@/plugins/OHST_V1_API';
Vue.prototype.$api.ohst = ohst.createApi(Vue.prototype.$tquery.getApi("ohst"));
import or from '@/plugins/OR_V1_API';
Vue.prototype.$api.or = or.createApi(Vue.prototype.$tquery.getApi("or"));
import osrd from '@/plugins/OSRD_V1_api';
Vue.prototype.$api.osrd = osrd.createApi(Vue.prototype.$tquery.getApi("osrd"));
import cb from '@/plugins/CB_V1_api';
Vue.prototype.$api.cb = cb.createApi(Vue.prototype.$tquery.getApi("cb"));
// *****************************AP结束*********************
//注册接口
Vue.prototype.$tquery.createApi("root", {
    dev: "/",
    prod: "/",
});

token.config({
    logoutCallback() {
        router.push({ name: "Login" })
    },
    router
})

Vue.mixin({
    methods: {
        logout() {
            token.logout();
        },
    },
})



const vm = new Vue({
    i18n,
    router,
    store: store,
    render: h => h(App)
}).$mount("#app");
